<template>
  <div>
    <h1>Reset Password</h1>
    <div v-if="fetching">
      <Loader></Loader>
    </div>
    <div v-if="!fetching">
      <div v-if="active">
        <form class="flexform" @submit.prevent="resetpw">
          <div>
            <label for="password"> Enter new password
              <input required name="password" type="password" v-model="password" />
            </label>
          </div>
          <div>
            <label for="repeatpassword"> Enter new password again
              <input required name="repeatpassword" type="password" v-model="repeatpassword" />
            </label>
          </div>
          <input type="submit" name="submit" value="Submit" />
        </form>
      </div>
      <div v-if="!active">
        Sorry, that reset key is invalid - codes only last an hour. <router-link to="/password/forgot"><a>Try again</a></router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/elements/Loader'
import API from '@/data/api.js'
import {store} from '@/store'
import router from '@/router'

export default {
  name: 'ResetPassword',
  components: {
    'Loader': Loader
  },
  data () {
    return {
      active: false,
      fetching: true,
      email: null,
      password: '',
      repeatpassword: '',
      token: null
    }
  },
  async beforeCreate () {
    if (this.$route.params.key) {
      try {
        let checkToken = await API.checkPasswordResetToken(this.$route.params.key)
        this.email = checkToken.email
        this.token = checkToken.token
        this.fetching = false
        this.active = true
      } catch (e) {
        console.log(e)
        this.fetching = false
        this.active = false
      }
    } else {
      this.fetching = false
      this.active = false
    }
  },
  methods: {
    async resetpw () {
      if (this.password !== this.repeatpassword || this.password === '') {
        store.commit('setAlert', {
          message: 'Passwords must match',
          type: 'warning'
        })
        return
      }
      let resetObj = {
        token: this.token,
        email: this.email,
        password: this.password
      }
      try {
        let resetPassword = await API.resetPassword(resetObj)
        if (resetPassword.api_token !== '') {
          store.commit('updateKey', {
            key: resetPassword.api_token
          })
          router.push({ path: '/' })
          store.commit('setAlert', {
            message: 'Password has been reset - you are now logged in with the new password.',
            type: 'message'
          })
        } else {
          store.commit('setAlert', {
            message: 'We have run into processing issues. <br />if you continue having problems, try <a href="/password/forgot">resetting it again</a>.',
            type: 'warning'
          })
        }
      } catch (e) {
        store.commit('setAlert', {
          message: e.response.data.message + ' Note, passwords must be greater than 6 characters and the <br />if you continue having problems, try <a href="/password/forgot">resetting it again</a>.',
          type: 'warning'
        })
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/pages/auth/ResetPassword.vue